// src/api/apiAirlines.js
import axios from "../utils/axios";

/**
 * Get all airlines with filters and pagination
 */
export const getAllAirlines = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("airlines", { params });
    return data;
};

/**
 * Get single airline by ID
 */
export const getAirline = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`airlines/${id}`);
    return data;
};

/**
 * Create new airline
 */
export const createAirline = async (req) => {
    try {
        const { data } = await axios.post("airlines", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createAirline error:", error);
        throw error;
    }
};

/**
 * Update existing airline
 */
export const updateAirline = async (id, req) => {
    try {
        const { data } = await axios.put(`airlines/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateAirline error:", error);
        throw error;
    }
};

/**
 * Delete airline (soft delete)
 */
export const deleteAirline = async (id) => {
    try {
        const { data } = await axios.delete(`airlines/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAirline error:", error);
        throw error;
    }
};

/**
 * Mass soft delete airlines
 */
export const massDeleteAirlines = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "airlines/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("massDeleteAirlines error:", error);
        throw error;
    }
};

/**
 * Restore airline from archive
 */
export const restoreAirline = async (id) => {
    try {
        const { data } = await axios.post(`airlines/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAirline error:", error);
        throw error;
    }
};

/**
 * Mass restore airlines from archive
 */
export const massRestoreAirlines = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "airlines/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("massRestoreAirlines error:", error);
        throw error;
    }
};

/**
 * Permanent delete airline
 */
export const forceDeleteAirline = async (id) => {
    try {
        const { data } = await axios.delete(`airlines/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAirline error:", error);
        throw error;
    }
};

/**
 * Mass permanent delete airlines
 */
export const massForceDeleteAirlines = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "airlines/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("massForceDeleteAirlines error:", error);
        throw error;
    }
};

/**
 * Get airlines for select dropdown
 */
export const getAirlinesForSelect = async () => {
    try {
        const { data } = await axios.get("airlines/for-select");
        return data;
    } catch (error) {
        console.error("getAirlinesForSelect error:", error);
        throw error;
    }
};
